import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=071ec3bb&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=071ec3bb&prod&lang=scss&scoped=true&"
import style1 from "./Create.vue?vue&type=style&index=1&id=071ec3bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ec3bb",
  null
  
)

export default component.exports